<!-- display-mobile-01 preview — Google video partners in-stream ad -->
<app-mobile-frame>
  <!-- START: Publisher page -->
  <div class="gvp-page">
    <!-- The partner site's own header, stubbed out: the ad is the subject. -->
    <span class="gvp-topbar placeholder"></span>

    <!-- START: Real ad -->
    <div class="gvp-ad d-flex flex-column align-items-center">
      <button type="button" class="gvp-close d-flex align-items-center justify-content-center" aria-label="Close ad">
        <i class="bi bi-x-lg"></i>
      </button>

      <img
        class="gvp-logo"
        src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
        alt=""
      />

      <div class="gvp-headline">{{ headline }}</div>
      <div class="gvp-url">{{ displayUrl }}</div>

      <a
        [href]="data.url"
        target="_blank"
        rel="noopener noreferrer"
        class="gvp-player"
      >
        <img *ngIf="thumbnailUrl; else noCreative" class="gvp-creative" [src]="thumbnailUrl" alt="" />

        <ng-template #noCreative>
          <div class="gvp-creative creative-missing">
            <ng-container *ngIf="isResolving; else askForVideo">
              Reading video formats&hellip;
            </ng-container>
            <ng-template #askForVideo>
              Add a {{ format }} video to see this preview
            </ng-template>
          </div>
        </ng-template>

        <!-- Player chrome, only drawn over a creative — it is unreadable on
             the grey empty slot. -->
        <ng-container *ngIf="thumbnailUrl">
          <span class="gvp-countdown">00:08</span>
          <span class="gvp-progress"></span>
        </ng-container>
      </a>

      <a
        [href]="data.url"
        target="_blank"
        rel="noopener noreferrer"
        class="gvp-cta"
        >{{ data.ctaText || "Your call to action" }}</a
      >
    </div>
    <!-- END: Real ad -->

    <!-- The article list the ad sits on top of; the last row clips at the frame -->
    <div class="gvp-list d-flex flex-column">
      <div *ngFor="let article of articles" class="gvp-row d-flex flex-row">
        <span class="gvp-thumb placeholder"></span>
        <div class="gvp-row-text d-flex flex-column">
          <span class="gvp-bar placeholder"></span>
          <span class="gvp-bar gvp-bar-short placeholder"></span>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Publisher page -->
</app-mobile-frame>
